//!#system	

<template>
	<v-card>
		<v-card-title>
			<span class="headline">Update avatar</span>
		</v-card-title>
		<v-card-text>
			<application-file
				:routeInfo="routeInfo" 
				v-model="model.avatar" 
				context="update" 
				fieldName="avatar" 
				:fieldInfo="fieldInfo" 
				parentKey="avatar_id"
				:parent="model"
			/>
		</v-card-text>
		<v-card-actions>
			<v-spacer></v-spacer>
			<v-btn color="primary" :loading="doingFormSubmission" :disabled="imageNotReady" @click="submit">Save</v-btn>
		</v-card-actions>
	</v-card>
</template>

<script>
import apiService from '@/apiService';
import ApplicationFile from '@/components/special/ApplicationFile';
export default {
	name: 'UserAvatarUpdate',
	components: {
		ApplicationFile
	},
	data() {
		return {
			routeInfo: {
				namespace: 'uac',
				pluarlName: 'users',
				id: this.$store.getters['authentication/currentUser'].id
			},
			fieldInfo: {},
			model: {
				avatar_id: '',
				avatar: {

				}
			},
			doingFormSubmission: false
		};
	},
	computed: {
		imageNotReady() {
			return !this.model.avatar_id;
		}
	},
	methods: {
		submit() {
			this.doingFormSubmission = true;
			apiService.call({
				path: '/_sys/internals/uac/update-my-avatar',
				method: 'POST',
				params: this.model
			}, (err, response) => {
				this.doingFormSubmission = false;
				if (err) {
					this.$store.dispatch('app/applyObjectError', {
						show: true,
						text: err 
					});
				} else {
					this.$emit('saved');
					this.$store.dispatch('app/applyObjectUpdated', {
						show: true,
						text: 'Your avatar has been updated.'
					});
				}
			});
		}
	}
}
</script>